import React from 'react';
import styled from 'styled-components';
import { DSCircularProgressIndicator } from '@elliemae/ds-circular-progress-indicator';

var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "m7hflj-0"
})(["display:flex;justify-content:center;margin-top:12px;"]);

var LoadingIndicator = function LoadingIndicator() {
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "ds-combobox_loading-indicator"
  }, /*#__PURE__*/React.createElement(DSCircularProgressIndicator, {
    size: "m"
  }));
};

export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map
